<template>
  <page-section title="Communications">
    <trombi :list="congresses">
    </trombi>
  </page-section>
</template>
<script>
import trombi from '@/components/valuation/trombi'
import pagesection from '@/components/pagesection'

export default {
  name: 'communications',
  props: {
    congresses: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
    }
  },

  components: {
    trombi,
    'page-section': pagesection
  }
}
</script>
